export default "__VITE_ASSET__a16bf9ee__"